import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getPersonalWeeklyCalendar() {
      return getState().calendar;
    },
    isRetrievePersonalWeeklyCalendarRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrievePersonalWeeklyCalendarRequestPending() {
      return getState().request.isPending;
    },
    isRetrievePersonalWeeklyCalendarRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
